import Analytics from '@module/analytics';

export function init() {
  const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  Analytics.trackSnowplowEvent({
    category: 'reduced-motion',
    action: 'prefers-reduced-motion',
    label: mediaQuery.matches,
  });
}
